import { RefObject } from 'react';

const scrollToRef = (
  ref: RefObject<HTMLDivElement>,
  alignment?: ScrollLogicalPosition
) => {
  return ref?.current
    ? ref.current.scrollIntoView({
        behavior: 'smooth',
        block: alignment || 'start',
      })
    : null;
};

export default scrollToRef;
